<template>
    <dialog ref="refModal" class="modal" open>
        <div class="modal-content">
            <slot name="content"></slot>

            <button v-if="showNo" @click="onChoose(false)" class="btn-icon btn-prev">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 65 52"><path fill-rule="evenodd" d="M62.27 37.466c1.86-.44 3.28-2.89 2.52-9-.76-6.11.05-11.24-.49-13.15-.55-1.91-1.07-3.63-12.26-1.18s-19.96 4.95-19.96 4.95 3.11-13.5 2.56-16.5c-.55-3-2.63-4.38-12.46 1.62-9.82 6-24.22 20.38-22.04 24.2 3.001 5.27 8.95 10.14 22.8 20.07 6.55 4.7 11.95 5.27 11.13-1.82-.82-7.09-1.98-12.77-1.98-12.77s24.29 4.97 30.17 3.57l.01.01Z" clip-rule="evenodd"/></svg>
            </button>
            <button v-if="showYes" @click="onChoose(true)" class="btn-icon btn-ok">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 107 85"><path d="M2.763 48.682c5.2 4.206 15.803 14.285 24.637 32.283 2.07 4.218 8.007 4.444 10.382.39C48.43 63.18 73.132 25.497 105.657 4.352c2.373-1.543.512-5.19-2.132-4.177-7.731 2.96-17.258 7.704-27.514 15.289-13.44 9.939-26.684 19.509-41.682 40.688 0 0-9.946-22.036-24.761-21.742-3.241.065-7.45 1.119-9.192 6.258-.981 2.895.008 6.093 2.386 8.015Z"/></svg>
            </button>
        </div>
    </dialog>
</template>

<script>
    import SvgNote from "./SvgNote";

    export default {
        name: "Modal",
        components: { SvgNote }
    }
</script>

<script setup>
    import { ref }         from "vue";

    import { useMainStore }     from "../stores/main";


    const refModal = ref(null);
    let props = defineProps(["showYes", "showNo"]);


    let emits = defineEmits(["onChoose"]);

    function onChoose (choice)
    {
        emits("onChoose", choice);
    }
</script>
